"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var google_map_react_1 = require("google-map-react");
var constants_1 = require("../../../constants");
var Constants_1 = require("../map/Constants");
/**
 * The day as it is being rebuilt.
 *
 * Deliberately not built on MapComponent: that base class clusters activity
 * markers and is tied to ACTIVITY_MAPPER, whereas this map has to show a
 * different thing — which stops have been booked so far, which one is being
 * asked about right now, and the driving between them. Drawing straight onto
 * the google.maps instance keeps the two from constraining each other.
 */
var ProposalMap = /** @class */ (function (_super) {
    __extends(ProposalMap, _super);
    function ProposalMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gmap = null;
        _this.overlays = [];
        return _this;
    }
    ProposalMap.prototype.componentDidUpdate = function () {
        this.draw();
    };
    ProposalMap.prototype.componentWillUnmount = function () {
        this.clear();
    };
    ProposalMap.prototype.clear = function () {
        this.overlays.forEach(function (o) { return o.setMap(null); });
        this.overlays = [];
    };
    ProposalMap.prototype.onMapLoaded = function (event) {
        this.gmap = event.map;
        this.draw();
    };
    ProposalMap.prototype.draw = function () {
        if (!this.gmap || typeof google === 'undefined') {
            return;
        }
        // The Maps key is restricted by referrer, so on a host it does not cover the
        // library loads but its constructors throw (RefererNotAllowedMapError). Never
        // let that escape into render() — it would take the whole page down with it.
        try {
            this.drawOverlays(this.gmap);
        }
        catch (e) {
            console.error('Kaartlagen konden niet worden getekend:', e);
        }
    };
    ProposalMap.prototype.drawOverlays = function (gmap) {
        var _this = this;
        this.clear();
        var map = this.props.map;
        if (!map) {
            return;
        }
        var bounds = new google.maps.LatLngBounds();
        var hasBounds = false;
        // Where the approver currently is in the day. Everything before this is
        // decided; everything after is still to come. Drawing the two differently
        // is what makes the map answer "how far through am I?" at a glance.
        var cursorMs = map.current ? new Date(map.current.start).getTime() : Infinity;
        // --- the driving ------------------------------------------------------
        (map.legs || []).forEach(function (leg) {
            if (!leg.path || leg.path.length < 2) {
                return;
            }
            var done = new Date(leg.end).getTime() <= cursorMs;
            var line = new google.maps.Polyline({
                map: gmap,
                path: leg.path.map(function (p) { return new google.maps.LatLng(p.lat, p.lng); }),
                geodesic: true,
                strokeColor: done ? Constants_1.COLORS.pathColor : '#9AA5AE',
                strokeOpacity: done ? 0.85 : 0.35,
                strokeWeight: done ? 5 : 3,
                zIndex: done ? 2 : 1,
            });
            _this.overlays.push(line);
            leg.path.forEach(function (p) { bounds.extend(new google.maps.LatLng(p.lat, p.lng)); hasBounds = true; });
        });
        // --- the stops --------------------------------------------------------
        var currentMs = map.current ? new Date(map.current.start).getTime() : null;
        (map.stops || []).forEach(function (stop) {
            if (!stop.lat || !stop.lng) {
                return;
            }
            var position = new google.maps.LatLng(stop.lat, stop.lng);
            bounds.extend(position);
            hasBounds = true;
            var isCurrent = currentMs !== null && new Date(stop.start).getTime() === currentMs;
            var marker = new google.maps.Marker({
                map: gmap,
                position: position,
                zIndex: isCurrent ? 6 : stop.confirmed ? 4 : 3,
                // The stop under discussion carries its time window, so the question in
                // the panel and the pin on the map are obviously the same stop.
                label: isCurrent
                    ? { text: "".concat(fmt(stop.start), "\u2013").concat(fmt(stop.end)), color: '#fff', fontSize: '11px', fontWeight: 'bold' }
                    : stop.confirmed
                        ? { text: String(stop.ordinal), color: '#fff', fontSize: '12px', fontWeight: 'bold' }
                        : undefined,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    // Booked stops are solid and numbered in the order they were added.
                    // Everything else is hollow, so how much of the day is still
                    // unaccounted for reads at a glance.
                    scale: isCurrent ? 26 : stop.confirmed ? 13 : 9,
                    fillColor: isCurrent
                        ? Constants_1.COLORS.blue
                        : stop.confirmed
                            ? Constants_1.COLORS.darkGreen
                            : stop.status === 'ambiguous' ? '#A8760C' : '#9B4A2F',
                    fillOpacity: isCurrent ? 0.95 : stop.confirmed ? 1 : 0.45,
                    strokeColor: Constants_1.COLORS.white,
                    strokeWeight: isCurrent ? 3 : 2,
                },
            });
            marker.setTitle([
                isCurrent ? '▶ Huidige vraag' : null,
                stop.number ? "".concat(stop.number, " \u2014 ").concat(stop.name || '') : 'Geen werklocatie in de buurt',
                "".concat(fmt(stop.start), "\u2013").concat(fmt(stop.end), " \u00B7 ").concat(stop.minutes, " min"),
            ].filter(Boolean).join('\n'));
            _this.overlays.push(marker);
        });
        // --- a halo around the stop currently being asked about ---------------
        if (map.current && map.current.lat) {
            var ring = new google.maps.Circle({
                map: gmap,
                center: new google.maps.LatLng(map.current.lat, map.current.lng),
                radius: 150,
                strokeColor: Constants_1.COLORS.blue,
                strokeWeight: 2,
                strokeOpacity: 0.9,
                fillColor: Constants_1.COLORS.blue,
                fillOpacity: 0.10,
                zIndex: 5,
            });
            this.overlays.push(ring);
            bounds.extend(new google.maps.LatLng(map.current.lat, map.current.lng));
            hasBounds = true;
        }
        if (hasBounds) {
            gmap.fitBounds(bounds);
            var zoom = gmap.getZoom();
            if (typeof zoom === 'number' && zoom > 15) {
                gmap.setZoom(15);
            }
        }
    };
    ProposalMap.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "proposal-map" },
            React.createElement(google_map_react_1.default, { bootstrapURLKeys: { key: constants_1.GOOGLE_API }, defaultCenter: Constants_1.AMSTERDAM_COORDS, defaultZoom: 8, onGoogleApiLoaded: function (event) { return _this.onMapLoaded(event); }, yesIWantToUseGoogleMapApiInternals: true })));
    };
    return ProposalMap;
}(React.Component));
exports.default = ProposalMap;
function fmt(d) {
    return new Date(d).toLocaleTimeString('nl-NL', {
        timeZone: 'Europe/Amsterdam', hour: '2-digit', minute: '2-digit',
    });
}
